import { initializeApp } from "@firebase/app";
import { Messaging, getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

let _messaging: Messaging | null = null;

const firebaseApp = initializeApp(firebaseConfig);

export const messaging = getMessaging(firebaseApp);

export const getMessagingInstance = () => {
    if (_messaging) return _messaging;
    if ("serviceWorker" in navigator && "PushManager" in window) {
        _messaging = getMessaging(firebaseApp);
        return _messaging;
    }
    throw new Error("This browser doesn't support Firebase Cloud Messaging.");
};

export const getOrRegisterServiceWorker = () => {
    if ("serviceWorker" in navigator && "PushManager" in window) {
        return window.navigator.serviceWorker.getRegistration("/firebase-push-notification-scope").then((serviceWorker) => {
            if (serviceWorker) {
                serviceWorker.update();
                return serviceWorker;
            }
            return window.navigator.serviceWorker.register("/firebase-messaging-sw.js", { scope: "/firebase-push-notification-scope" });
        });
    }
    throw new Error("The browser doesn`t support service worker.");
};
export const getFirebaseToken = () => {
    try {
        return getOrRegisterServiceWorker().then((serviceWorkerRegistration) =>
            getToken(getMessagingInstance(), {
                vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
                serviceWorkerRegistration,
            }).then((token: string) => token),
        );
    } catch (error) {
        throw new Error("Error on getFirebaseToken");
    }
};

export const onForegroundMessage = (callback: (payload: any) => void) => {
    return new Promise((resolve) => {
        onMessage(getMessagingInstance(), (payload) => {
            callback(payload);
            resolve(payload);
        });
    });
};

export const isCompatibleBrowserPushNotification = (): boolean => {
    if ("Notification" in window) {
        return true;
    }
    return false;
};
